import { UnplugIcon } from "lucide-react";
import "./McpServerTile.scss";
import { useNavigate } from "react-router-dom";
import { linkToMcpServer } from "../../../routes";

const McpServerTile = ({ server }) => {
  const nav = useNavigate();
  return (
    <div
      className="mcp_server_tile"
      onClick={() => nav(linkToMcpServer(server.uid))}
    >
      <div className="title_row">
        <div className="icon_container">
          <div className="icon_circle">
            <UnplugIcon size={24} color="#67748e" />
          </div>
        </div>
        <div className="title_column">
          <div className="title_value">{server.name}</div>
          <div className="slug_container">
            <div className="slug" title={server.slug}>
              {server.slug}
            </div>
          </div>
        </div>
      </div>
      <div className="description_container">
        <div className="description">{server.description}</div>
      </div>
    </div>
  );
};

export default McpServerTile;
